import type { BlockContent } from 'components/editor/grid/reduxStore/editorSlice';
import type { BlockConfig } from 'components/editor/GridDndEditor/models/BlockConfig.model';
import type { BlockSettings } from 'components/editor/grid/reduxStore/blockStyleSettingsSlice';

const defaultBorderWidth = {
  borderLeft: 0,
  borderRight: 0,
  borderTop: 0,
  borderBottom: 0,
};

export const isCircularRadius = (
  radius: number,
  { width, height }: Pick<BlockConfig, 'width' | 'height'>,
  borderWidth?: Partial<BlockSettings>
) => {
  const { borderLeft, borderRight, borderTop, borderBottom } = { ...defaultBorderWidth, ...borderWidth };
  const adjustedWidth = width - borderLeft - borderRight;
  const adjustedHeight = height - borderTop - borderBottom;

  const minDimension = Math.min(adjustedWidth, adjustedHeight);
  const threshold = minDimension / 2;

  return radius >= threshold;
};

export const useCircularShape = (blockContent: BlockContent) => {
  if (!blockContent) {
    return { wouldBeCircular: () => false };
  }

  const wouldBeCircular = (radius: number, borderWidth?: Partial<BlockSettings>) =>
    isCircularRadius(radius, blockContent.blockConfig as BlockConfig, borderWidth);

  return { wouldBeCircular };
};
